import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card text-center p-0 gy-2" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.counters, (counter, key) => {
          return (_openBlock(), _createBlock("div", {
            class: "col-sm-6",
            key: key
          }, _toDisplayString(counter.name) + ": " + _toDisplayString(counter.value), 1))
        }), 128))
      ])
    ])
  ]))
}